export default "__VITE_ASSET__7517fc59__"